export default __webpack_public_path__ + "static/media/花瓣1.b36c0e34.svg";